import React, { useEffect } from 'react';
import styles from '../../styles/AsignacionBecasStyles/AsignacionBecas.module.css';

function ScholarshipSummaryModal({ isOpen, onClose, onConfirm, student }) {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleDownload = () => {
    console.log('Descargar resumen de asignación de beca');
    // TODO: Implementar descarga/PDF del resumen
  };

  const handleCancel = () => {
    onClose();
  };

  const handleConfirm = () => {
    console.log('Confirmar asignación de beca');
    onConfirm();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalBackdrop} onClick={handleBackdropClick}>
      <div className={styles.summaryModalContainer}>
        <div className={styles.summaryModalHeader}>
          <h2 className={styles.summaryModalTitle}>Resumen de Asignación de Beca</h2>
          <button className={styles.modalCloseButton} onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <div className={styles.summaryModalBody}>
          <div className={styles.summaryCard}>
            <div className={styles.summaryCardHeader}>
              <h3 className={styles.summaryCardTitle}>Información de la beca</h3>
            </div>
            
            <div className={styles.summaryCardContent}>
              <div className={styles.summaryInfoGrid}>
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Estudiante:</span>
                  <span className={styles.summaryValue}>
                    Daniel Alejandro Martínez Rivas (01-000123)
                  </span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Tipo de beca:</span>
                  <span className={styles.summaryValue}>Económica</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Porcentaje aplicado:</span>
                  <span className={styles.summaryValue}>%35</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Fecha inicio:</span>
                  <span className={styles.summaryValue}>30/09/2025</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Fecha fin:</span>
                  <span className={styles.summaryValue}>15/06/2026</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Motivo:</span>
                  <span className={styles.summaryValue}>"Necesidad económica"</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Impacto estimado en fondos:</span>
                  <span className={styles.summaryValue}>$72,000.00</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Fondos disponibles actualmente:</span>
                  <span className={styles.summaryValue}>$450,000.00</span>
                </div>
                
                <div className={styles.summaryInfoRow}>
                  <span className={styles.summaryLabel}>Autorizado por:</span>
                  <span className={styles.summaryValue}>Nombre Apellido</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div className={styles.summaryModalActions}>
          <button 
            type="button" 
            className={styles.downloadButton}
            onClick={handleDownload}
          >
            <svg className={styles.downloadIcon} viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Descargar
          </button>
          
          <div className={styles.summaryActionButtons}>
            <button 
              type="button" 
              className={styles.cancelButton}
              onClick={handleCancel}
            >
              CANCELAR
            </button>
            <button 
              type="button" 
              className={styles.confirmButton}
              onClick={handleConfirm}
            >
              CONFIRMAR
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ScholarshipSummaryModal;
